import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    component: String,
    props: Object,
    event: String,
  };

  connect() {
    void this.loadComponent();
    window.afterSuccessfulLogin = this.afterSuccessfulLogin.bind(this);
    window.popupclosed = this.popupClosed.bind(this);
  }

  async loadComponent() {
    try {
      window.microFrontendRenderFunctions = window.microFrontendRenderFunctions || {};
      this.renderComponent();
    } catch (error) {
      console.error('Load Component Error:', error);
    }
  }

  renderComponent() {
    try {
      const renderFunction = window.microFrontendRenderFunctions[`render${this.componentValue}`];
      renderFunction(this.element, this.propsValue || {});
    } catch (error) {
      console.error('Render function execution failed:', error);
    }
  }

  afterSuccessfulLogin(target) {
    window.GTM.pushEvent({ name: this.eventValue, payload: { action: 'login' } });

    if (!target) {
      window.location.reload();
      return;
    }
    // We must use location.reload because the target URL in some cases contains a hash which freezes the modal
    if (window.location.href === target.href) {
      window.location.reload();
      return;
    }
    window.location = target;
  }

  popupClosed() {
    this.afterSuccessfulLogin();
  }
}
